import axios from "axios/index";
import api from "../../config/_api";
import {DISPLAY_UNIT_UPDATED} from "../actions/display_unit";

const state = {
    display_unit: []
};

const actions = {
    getUnit:({commit}, payload) => {
        
            return new Promise((resolve, reject) => {
                axios({url: api.url + 'display_unit?id=' + payload.id, method: 'GET'})
                  .then(resp => {
                    commit('DISPLAY_UNIT_UPDATED', resp.data);
                    resolve(resp.data); // résoudre la promesse avec la réponse
                  })
                  .catch(err => {
                    reject(err); // rejeter la promesse avec l'erreur
                  });
              });
    },
  
};
const mutations = {
    [DISPLAY_UNIT_UPDATED]: (state, display_unit) => {
        state.display_unit = display_unit;
    },
   
};


const getters = {
    display_unit : state => state.display_unit,
};
const defaultPopperProps = {
    arrowPosition: 'start',
    arrowOffsetScaling: 1,
    popperOptions: {
      placement: 'bottom-start',
      positionFixed: true,
      // more options in https://popper.js.org
    },
  }
export default {
    namespaced: true,
    state,
    actions,
    mutations,
    defaultPopperProps,
    getters
};
